module.exports = require('./helpers/bundle-url').getBundleURL('1HPSI') + "logo.c51670a8.svg";